<template>
  <div class="publish-wrap user-info">
    <button
      class="button-publish-library"
      @click.stop="toggleMenuOpen"
    >
      <span class="text">
        {{ userName }}
      </span>
    </button>
    <div
      class="publish-dropdown" :class=" { 'user-info' : toggleBaseMenu }"
      v-if="toggleBaseMenu === 'user-info'"
    >
      <ul>
        <li class="content">
          <div class="content-url">
            <img
              src="@/assets/images/user_grey_dark_icon.svg"
              alt="icon"
              class="user-info-icon"
            />
            <span class="text">
            {{ fullName }}
          </span>
          </div>
          <span class="text my-account"
                v-if="isExternalUser"
                @click="myAccount"
          >
            {{ $t("MY_ACCOUNT") }}
          </span>
        </li>
        <li class="content lang">
          <button
            class="button-lang"
            @click.stop="openLangOptions"
          >
            <img
              src="@/assets/images/world.svg"
              class="icon-world user-info-icon"
            />
            <span class="text">
              {{ $t("LANGUAGE") }}
            </span>
            <img
              src="@/assets/images/arrow_filter_side_bar.svg"
              class="arrow-down"
              :class="{'open':isLangOpen}"
            />
          </button>
        </li>
        <li>
          <ul
            class="lang-dropdown"
            v-if="isLangOpen"
          >
            <li
              class="content"
              v-for="(langObj, index) in langOptions"
              :class="highlightLang(langObj.lang)"
              :key="index"
              @click="selectLang(langObj)"
            >
              {{ langObj.lang }}
            </li>
          </ul>
        </li>
        <li class="footer">
          <button
            data-testId="signOutButton"
            @click="signOut"
            class="sign-out-button"
          >
            <span>{{ $t("SIGN-OUT") }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { langObjArr } from '@/constants.js'

export default {
  name: 'user-info',
  data () {
    return {
      isLangOpen: false,
      langOptions: langObjArr
    }
  },
  computed: {
    ...mapState({
      isExternalUser: state => state.base.user.external,
      user: state => state.base.user,
      publishOptionsOpen: state => state.base.publishOptionsOpen,
      toggleBaseMenu: state => state.base.toggleBaseMenu,
      userLang: state => state.base.lang
    }),
    userName () {
      const firstNameLetter = this.user && this.user.firstName ? this.user.firstName[0] : ''
      const lastNameLetter = this.user && this.user.lastName ? this.user.lastName[0] : ''
      const user = firstNameLetter + '.' + lastNameLetter
      return user
    },
    fullName () {
      return this.user?.firstName + ' ' + this.user?.lastName
    }
  },
  watch: {
    toggleBaseMenu () {
      if (this.toggleBaseMenu !== 'user-info') {
        this.isLangOpen = false
      }
    }
  },

  methods: {
    ...mapActions({
      setLanguage: 'setLang',
      toggleBaseLibraryMenu: 'toggleBaseLibraryMenu'
    }),
    myAccount () {
      const url = process.env.VUE_APP_IDM_ACCOUNT
      window.open(url, '_blank')
    },
    signOut () {
      this.$store.dispatch('signOut')
      this.$router.push({ name: 'homePage' })
    },
    async toggleMenuOpen () {
      if (this.toggleBaseMenu === 'user-info') {
        await this.toggleBaseLibraryMenu(null)
      } else {
        await this.toggleBaseLibraryMenu('user-info')
      }
    },
    openLangOptions () {
      this.isLangOpen = !this.isLangOpen
    },
    selectLang (lang) {
      this.setLanguage(lang)
    },
    highlightLang (lang) {
      if (this.userLang.lang === lang) {
        return ' bold'
      }
      return null
    }
  }
}
</script>

<style>
.content .bold {
  font-weight: 600;
}
</style>
